import { jsx as _jsx } from "react/jsx-runtime";
import classNames from 'classnames';
import { SidebarItemContext } from './SidebarItemContext';
const SidebarItemGroup = ({ children, ...rest }) => {
    return (_jsx("ul", { className: classNames('mt-4 space-y-2 border-t border-gray-200 pt-4 first:mt-0 first:border-t-0 first:pt-0 dark:border-gray-700'), "data-testid": "sidebar-item-group", ...rest, children: _jsx(SidebarItemContext.Provider, { value: { insideCollapse: false }, children: children }) }));
};
SidebarItemGroup.displayName = 'Sidebar.ItemGroup';
export default SidebarItemGroup;
